import { axiosAjax } from './common'

export default {
  // get sshkey list
  getList (params) {
    return axiosAjax('/account_pubkey', 'get', params)
  },
  // delete sshkey
  delKey (id) {
    return axiosAjax('/account_pubkey/' + id, 'delete')
  },
  // add sshkey
  addKey (params) {
    return axiosAjax('/account_pubkey', 'post', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/sshkey.js